import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import { Typography } from 'aquilla/core/atoms/Typography';
import React from 'react';

const Empty = styled.div`
  width: 452px;
  text-align: center;
  margin: ${Spacings.SPACING_24B} auto ${Spacings.SPACING_32B};

  ${mediaQuery.uptoMobile} {
    margin: 0 auto ${Spacings.SPACING_16B};
  }
`;
const EmptyImage = styled.img`
  user-drag: none;
  user-select: none;
`;
const NoCourses = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const EducatorEmptyCourse = ({ header, detail }) => {
  return (
    <Empty>
      <EmptyImage src={`${getImage('empty-state.svg')}`} alt="" />
      <NoCourses variant="h3">{header}</NoCourses>
      <Typography variant="p1" color="var(--color-text-secondary)">
        {detail}
      </Typography>
    </Empty>
  );
};

export default EducatorEmptyCourse;
